import React from 'react';

import {Provider} from "components/client/ClientContext";
import {ClientList} from "components/client/ClientList";

export const Clients = () => {

    return (
        <Provider>
            <ClientList/>
        </Provider>
    );
}
